import React from 'react';
import { Chip } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AssessmentIcon from '@mui/icons-material/Assessment';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { getNotificationStyle } from '../../utils/notificationStyle';

const NotificationStatusChip = ({ notification }) => {
    const { statusLabel, statusColor, pulse } = getNotificationStyle(notification);
    const Icon = statusLabel === 'RESOLVED' ? CheckCircleOutlineIcon
               : statusLabel === 'REPORT'   ? AssessmentIcon
               : FiberManualRecordIcon;

    return (
        <Chip
            label={statusLabel}
            size="small"
            icon={<Icon sx={{ fontSize: 12, animation: pulse ? 'blui-pulse 1.5s infinite' : 'none' }} />}
            sx={{
                bgcolor: statusLabel === 'RESOLVED' ? 'transparent' : statusColor,
                color: statusLabel === 'RESOLVED' ? statusColor : '#fff',
                border: statusLabel === 'RESOLVED' ? `1px solid ${statusColor}` : 'none',
                fontWeight: 700,
                fontSize: 11,
                letterSpacing: '0.06em',
                height: 22,
            }}
        />
    );
};

export default NotificationStatusChip;
